export type DemoVideo = {
  title: string;
  url: string;
};

export type DemoSection = {
  id: string;
  img: string;
  demos: DemoVideo[];
};

const demoData: DemoSection[] = [
  {
    id: "Telegram Bulk Sender",
    img: "/other-tools/tg-bulk-sender.png",
    demos: [
      {
        title: "How to send Bulk Messages on Telegram Web?",
        url: "https://www.youtube.com/embed/_N7-iFk5cRk",
      },
    ],
  },
  {
    id: "Telegram Video Downloader",
    img: "/other-tools/tg-video-downloader.png",
    demos: [
      {
        title: "How to download videos from Telegram Web?",
        url: "https://www.youtube.com/embed/jDFMOBT8n2k",
      },
    ],
  },
  {
    id: "Telegram Web Translator",
    img: "/other-tools/tg-translator.png",
    demos: [
      {
        title: "How to Translate Telegram Web Messages?",
        url: "https://www.youtube.com/embed/Mid0uRvln0s",
      },
    ],
  },
  {
    id: "Free Tools",
    img: "/bulb.png",
    demos: [
      {
        title: "Telegram Web Privacy — quick demo",
        url: "https://www.youtube.com/embed/OXeTc3IT_RU",
      },
    ],
  },
];

export default demoData;
